import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import config from 'constants/apiConfig';
import axios from 'axios';

export const keys = {
  incidentWorkspaceTeamStatus: 'incidentWorkspaceTeamStatus',
};

export const useFetchIncidentWorkspaceTeamStatus = () => {
  const incidentId = useSelector(
    (state: { app: { currentIncident?: { id: UUID } } }) =>
      state.app.currentIncident?.id
  );
  return useQuery({
    queryKey: [keys.incidentWorkspaceTeamStatus, incidentId],
    queryFn: async () => {
      const response = await axios(config.apiGateway.fetchIncidentStatus, {
        method: 'POST',
        data: {
          incidentId,
        },
      });

      return response?.data?.[0]?.teams_status;
    },
    enabled: Boolean(incidentId),
  });
};
